


import React, {Component, Fragment} from 'react';
import dateformat from 'dateformat';
import {GridColumn, Grid} from '@atlaskit/page';
import {TextField, DatePickerField, SelectField, TextAreaField} from '../../../components/FormFields';
import Button, { ButtonGroup } from '@atlaskit/button';
import {FormFooter} from '@atlaskit/form';
import styled from 'styled-components';
import FieldSelect from '../../../components/FieldSelect';
import i18n from 'i18next';
import {Trans} from 'react-i18next';

const TaskTitle = styled.div`
  min-height: 40px;
  display: flex;
  align-items: center;
`;

const DEFAULT_DEALER_VALUE = {
  id: -1,
  name: i18n.t('clients:Self-serviced')
};

export default class CarTOEditForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      TOTasks: null,
      TO: {
        id: '',
        odometer: 0,
        date: dateformat(Date.now(), 'yyyy-mm-dd'),
        dealer: DEFAULT_DEALER_VALUE,
        comment: '',
        tasks: {},
      },
    };
  }

  componentDidMount() {
    const {
      dictionaries,
      getDictionaries,
      data,
    } = this.props;

    if (!dictionaries.companies.data) {
      (getDictionaries('companies'))();
    }
    if (!dictionaries.TOTaskTypes.data) {
      (getDictionaries('TOTaskTypes'))();
    }
    if (!dictionaries.TOTasks.data) {
      (getDictionaries('TOTasks'))();
    } else {
      this.setState({
        TOTasks: prepareTasks(data.id, dictionaries.TOTasks.data),
      });
    }

    if (data) {
      this.setState({
        TO: {...this.state.TO, ...data},
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dictionaries.TOTasks.fetching 
      && prevProps.dictionaries.TOTasks.fetching !== this.props.dictionaries.TOTasks.fetching
      && !this.props.dictionaries.TOTasks.error) {
        this.setState({
          TOTasks: prepareTasks(this.state.TO.id, this.props.dictionaries.TOTasks.data),
        });
    }
    if (prevProps.fetching
      && prevProps.fetching !== this.props.fetching
      && !this.props.error
    ) {
        this.props.onClose();
    }
  }

  componentWillUnmount() {
    if (this.props.edit) {
      this.props.onClose();
    }
  }

  onCheckFormSubmit = e => {
    e.preventDefault();
    this.props.onCheckCar(this.state.car.vin, this.state.car.epts);
  }

  onFormSubmit = e => {
    e.preventDefault();
    this.props.onSave({
      id: this.props.carId,
      TO: this.state.TO
    });
  }

  onChange = (name, value) => {
    if (name.includes('tasks.')) {
      const path = name.split('.');
      if (path.length === 2) {
        let tasks = {...this.state.TO.tasks};
        if (value.id === '-') {
          delete tasks[path[1]];
        } else {
          tasks[path[1]] = value.id;
        }
        
        this.setState({
          TO: {...this.state.TO, tasks},
        });
      }
    } else {
      this.setState({
        TO: {...this.state.TO, [name]: value},
      });
    }
  }

  render () {
    const {
      dictionaries,
      fetching,
      onClose,
    } = this.props;

    const {
      id,
      odometer,
      date,
      dealer,
      comment,
      tasks,
    } = this.state.TO;

    const dealers = dictionaries.companies.data ? [DEFAULT_DEALER_VALUE, ...dictionaries.companies.data.filter(c => c.type === "Dealer")] : [DEFAULT_DEALER_VALUE];
    const currentDealer = dealers && dealer ? dealers.find(r => r.id === dealer.id) : dealers[0];

    return (
      <GridColumn medium={12}>
        <form onSubmit={this.onFormSubmit}>
          <Grid>
            <GridColumn medium={4}>
              <TextField
                name='id'
                label={i18n.t('clients:TO number')}
                placeholder={i18n.t("clients:Enter TO's number")}
                required={true}
                onChange={this.onChange}
                isDisabled={true}
                value={id}
              />
            </GridColumn>
            <GridColumn medium={8}>

            </GridColumn>
            <GridColumn medium={4}>
              <TextField
                name='odometer'
                label={i18n.t('clients:Mileage (km)')}
                placeholder={i18n.t('clients:Enter mileage')}
                required={true}
                onChange={this.onChange}
                isDisabled={fetching}
                value={odometer}
              />
            </GridColumn>
            <GridColumn medium={4}>
              <DatePickerField
                name='date'
                label={i18n.t('clients:Date')}
                placeholder={i18n.t('ddmmyyyy')}
                required={true}
                onChange={this.onChange}
                isDisabled={fetching}
                value={date}
              />
            </GridColumn>
            <GridColumn medium={4}>
              <SelectField
                name='dealer'
                label={i18n.t('clients:Dealer')}
                value={currentDealer}
                required={true}
                onChange={this.onChange}
                data={dealers}
                fetching={dictionaries.companies.fetching}
                isDisabled={fetching || dictionaries.companies.fetching}
              />
            </GridColumn>
            <GridColumn medium={12}>
              <TextAreaField
                name='comment'
                placeholder={i18n.t('clients:Note')}
                required={false}
                onChange={this.onChange}
                isDisabled={fetching}
                value={comment}
              />
            </GridColumn>
            {dictionaries.TOTasks.data &&
              dictionaries.TOTaskTypes.data &&
              this.state.TOTasks &&
              this.state.TOTasks.map(group => (
              <Fragment key={group.title}>
                <GridColumn medium={12}>
                  <h4 style={{paddingTop: 16}}>{group.title}</h4>
                </GridColumn>
                {group.tasks.map(itm => (
                  <Fragment key={itm.id}>
                    <GridColumn medium={9}>
                      <TaskTitle>{itm.title}</TaskTitle>
                    </GridColumn>
                    <GridColumn medium={1}>
                      <TaskTitle>{itm.type}</TaskTitle>
                    </GridColumn>
                    <GridColumn medium={2}>
                      <FieldSelect
                        name={itm.id}
                        keyName={`tasks.${itm.id}`}
                        value={getTOTaskTypesValue(dictionaries.TOTaskTypes.data, tasks[itm.id])}
                        onChange={this.onChange}
                        data={dictionaries.TOTaskTypes.data}
                        isDisabled={fetching || dictionaries.TOTaskTypes.fetching}
                      />
                    </GridColumn>
                  </Fragment>
                ))}
              </Fragment>
            ))}
            <GridColumn medium={12}>
              <FormFooter>
                <ButtonGroup>
                  <Button appearance='subtle' isDisabled={fetching} onClick={onClose}>
                    <Trans>
                      Cancel
                    </Trans>
                  </Button>
                  <Button type='submit' isDisabled={fetching} isLoading={fetching} appearance='danger'>
                    <Trans>
                      Save
                    </Trans>
                  </Button>
                </ButtonGroup>
              </FormFooter>
            </GridColumn>
        </Grid>
        </form>
      </GridColumn>
    )
  }
}

const getTOTaskTypesValue = (data, id) => {
  return (data && id && data.find(t => t.id === id)) || data[0];
}

export const prepareTasks = (id, TOTasks, tasks) => {
  let result = null;
  if (TOTasks
    && TOTasks.length 
    && TOTasks.length > 0 
    && TOTasks[0].length 
    && TOTasks[0].length 
    && TOTasks[0].length === 10
  ) {
    result = [];
    let groupName = '';
    let group = [];
    TOTasks.forEach(itm => {
      const obj = {
        id: itm[0],
        groupTitle: itm[1],
        title: itm[2],
        'ТО-0': itm[3],
        'ТО-1': itm[4],
        'ТО-2': itm[5],
        'ТО-3': itm[6],
        'ТО-4': itm[7],
        'ТО-5': itm[8],
        'ТО-6': itm[9]
      };
      if (obj[id]) {
        if (groupName !== obj.groupTitle) {
          group && group.length && group.length > 0 && result.push({title: groupName, tasks: group});
          groupName = obj.groupTitle;
          group = [];
        }
        group.push({
          id: obj.id,
          title: obj.title,
          type: obj[id],
          complete: tasks ? tasks[obj.id] : undefined
        });
      }
    })
  }
  return result;
}